<h2 class="userscreen-title mt-1"><button (click)="backClicked()" class="btn-xs back-page">Back</button></h2>
<div style="background: #DFE8E9;" class="container-fluid">
  <div class="card">
    <div class="card-header p-2 d-flex align-items-center w-100 justify-content-between">
      <h6 id="addAccountButton" class="float-left mb-0">Add funds</h6>
      <div class="form-group mb-0 mb-0 d-flex">
        <!-- <button class="btn btn-success btn-sm" style="background: #dc3545;" (click)="addDepositRequest()">Add
          Funds</button> -->
        <!-- <button class="btn btn-secondary btn-sm" style="margin-left:3px !important"
          (click)="addManualDepositRequest()">Manual
          Deposit</button> -->
      </div>
    </div>
    <div class="card-body redtablehead p-0 m-0">
      <mat-tab-group [(selectedIndex)]="selectedTabIndex" dynamicHeight mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="Instent deposit">
          <div class="deposit-form">
            <h5>Wallet - Deposit</h5>
            <div class="form-group">
              <label for="depositAmount">Enter Amount:</label>
              <input type="number" [(ngModel)]="depositAmount" class="form-control" id="depositAmount"
                placeholder="Amount">
            </div>
            <div class="btn-group">
              <button (click)="addAmount(100)" class="btn btn-primary">+100</button>
              <button (click)="addAmount(500)" class="btn btn-primary">+500</button>
              <button (click)="addAmount(1000)" class="btn btn-primary">+1000</button>
              <button (click)="addAmount(5000)" class="btn btn-primary">+5000</button>
              <button (click)="addAmount(10000)" class="btn btn-primary">+10000</button>
              <button (click)="addAmount(100000)" class="btn btn-primary">+100000</button>
            </div>
            <br><br>
            <div class="payment-actions">
              <button class="btn btn-danger" (click)="clearAmount()">Clear</button>
              <button class="btn btn-success" [disabled]="isDepositProceed" (click)="proceedDeposit()">
                <span *ngIf="isDepositProceed">
                  <i class="spinner-border spinner-border-sm"></i> Processing...
                </span>
                <span *ngIf="!isDepositProceed">Proceed</span>
              </button>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Manual deposit">
          <form [formGroup]="depositForm" class="manual-deposit-wrapper">
            <p *ngIf="errorMsg" class="alert alert-danger m-1 p-1">{{ errorMsg }}</p>

            <div class="form-group">
              <label class="label">Select Payment Method</label>
              <div class="method-options">
                <label *ngIf="is_gpayActive">
                  <input type="radio" formControlName="method" value="gpay" (click)="toggleUpiTextbox()"
                    (change)="chooseMethod($event)" [(ngModel)]="methodval"> Google Pay
                </label>
                <label *ngIf="is_paytmActive">
                  <input type="radio" formControlName="method" value="paytm" (click)="toggleUpiTextbox()"
                    (change)="chooseMethod($event)" [(ngModel)]="methodval"> PayTm
                </label>
                <label *ngIf="is_phonepeActive">
                  <input type="radio" formControlName="method" value="phonepe" (click)="toggleUpiTextbox()"
                    (change)="chooseMethod($event)" [(ngModel)]="methodval"> PhonePe
                </label>
                <label *ngIf="is_qrActive">
                  <input type="radio" formControlName="method" value="qrcode" (click)="toggleUpiTextbox()"
                    (change)="chooseMethod($event)" [(ngModel)]="methodval"> QR Code
                </label>
                <label *ngIf="is_otherActive">
                  <input type="radio" formControlName="method" value="other" (click)="toggleUpiTextbox()"
                    (change)="chooseMethod($event)" [(ngModel)]="methodval"> Bank
                </label>
              </div>
              <div class="text-danger"
                *ngIf="depositFormControl.method.touched && depositFormControl.method.errors?.required">
                Please select method.
              </div>
            </div>

            <div class="paybox text-center m-2">
              <img *ngIf="selected_radio=='qrcode'; else elseIfblock" style="width:150px" [src]="qrcode">
              <ng-template #elseIfblock>
                <span *ngIf="selected_radio=='other'; else elseBlock" [innerHtml]="currentPayment"></span>
              </ng-template>
              <ng-template #elseBlock>
                {{ currentPayment }}
                <div style="text-align:center; margin-top: 40px;">
                  <h2>Scan to Pay via UPI</h2>
                  <img *ngIf="qrImageSrc" [src]="qrImageSrc" alt="UPI QR Code" />
                </div>
              </ng-template>

              <a *ngIf="selected_radio=='qrcode';else elseIfblock2;" href="{{this.qrcode}}"
                class="material-symbols-outlined copybtn" style="float: right; cursor: pointer;" target="_blank"
                download>
                download
              </a>
              <ng-template #elseIfblock2>
                <span *ngIf="selected_radio!='qrcode'" (click)="copyMessage(currentPayment)"
                  class="material-symbols-outlined copybtn" style="float: right; cursor: pointer;">
                  content_copy
                </span>
              </ng-template>
            </div>

            <!-- UTR INPUT -->
            <div class="form-group" *ngIf="showUpiTextbox">
              <label class="label">UTR/Reference No.</label>
              <input type="text" formControlName="transaction_id" class="custom-input" placeholder="Enter UTR/Ref. No.">
              <span class="text-danger"
                *ngIf="(depositFormControl.transaction_id.touched || submitted) && depositFormControl.transaction_id.errors?.required">
                UTR/Ref. No. is required
              </span>
            </div>

            <!-- AMOUNT INPUT -->
            <div class="form-group">
              <label class="label">Amount</label>
              <input type="number" formControlName="amount" class="custom-input" placeholder="Enter amount">
              <span class="text-danger"
                *ngIf="(depositFormControl.amount.touched || submitted) && depositFormControl.amount.errors?.required">
                Amount is required
              </span>
            </div>

            <!-- UPLOAD SECTION -->
            <div class="form-group">
              <label class="label">Upload Screenshot</label>
              <div class="upload-box" (click)="fileInput.click()">
                📤 Click to Upload Transaction Screenshot
                <span *ngIf="selectedFileName" class="file-indicator">✔ {{ selectedFileName }}</span>
              </div>
              <input #fileInput type="file" formControlName="depo_proof" (change)="onFileSelected($event)"
                class="d-none">
              <div class="text-danger"
                *ngIf="(depositFormControl.depo_proof.touched || submitted) && depositFormControl.depo_proof.errors?.required">
                Please upload screenshot
              </div>
            </div>

            <!-- HIDDEN USERNAME -->
            <input type="hidden" formControlName="username">

            <!-- BUTTONS -->
            <div class="text-left mt-3">
              <button class="submit-btn" (click)="submitManualDepositRequest()">SUBMIT</button>
            </div>
          </form>
        </mat-tab>
      </mat-tab-group>
      <div class="overflow-auto">
        <table class="table table-sm table-bordered table-striped table-hover clearfix text-white">
          <thead>
            <tr>
              <th>Id</th>
              <th>Method</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody *ngIf="deposit_requests.length>0 && deposit_requests !=null">
            <tr *ngFor="let deposit_request of deposit_requests; let i = index">
              <td>{{i + 1}}</td>
              <td>{{deposit_request.method}}</td>
              <td>{{deposit_request.amount}}</td>
              <td>{{deposit_request.status == 0 ? 'Pending' : (deposit_request.status == -1 ? 'Declined' :
                'Approved')}}
              </td>
              <!-- <td>{{deposit_request.updated_at | date:'medium':'IST' }}</td> -->
              <td>{{deposit_request.updated_at | date:'medium':'IST'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>